// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_dl-0";
export var actionModalContentContainer = "_dl-1";
export var createTagButton = "_dl-2";
export var footerContainer = "_dl-7";
export var fullWidthDivider = "_dl-3";
export var hasCreateTagButton = "_dl-4";
export var noCreateTagButton = "_dl-5";
export var tagsContainer = "_dl-6";
export var tagsModalContentContainer = "_dl-8";